import {
  createContext,
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from "react";

type State = string | null;

const AccordionStateContext = createContext<State>(null);
const AccordionDispatchContext = createContext<
  Dispatch<SetStateAction<State>> | undefined
>(undefined);

const AccordionProvider: FC<{ props?: ReactNode }> = ({ children }) => {
  const [activeId, setActiveId] = useState<string | null>(null);

  return (
    <AccordionStateContext.Provider value={activeId}>
      <AccordionDispatchContext.Provider value={setActiveId}>
        {children}
      </AccordionDispatchContext.Provider>
    </AccordionStateContext.Provider>
  );
};

const useAccordionState = () => {
  const context = useContext(AccordionStateContext);

  if (context === undefined) {
    throw new Error("useAccordionState must be used within AccordionProvider");
  }

  return context;
};

const useAccordionDispatch = () => {
  const context = useContext(AccordionDispatchContext);

  if (context === undefined) {
    throw new Error(
      "useAccordionDispatch must be used within AccordionProvider"
    );
  }

  return context;
};

export { AccordionProvider, useAccordionState, useAccordionDispatch };
